export default "__VITE_ASSET__BsSD6Scf__"